import { OptionPreset } from "../../../../../common/sesh_types";

export function RSVPOptionsTable(props: { options: OptionPreset }) {
	const rows = [];

	let index = 0;
	for (let option of props.options.custom_options) {
		let emoji_element: JSX.Element;
		if (option.custom_emoji_data) {
			const emoji_url =
				`https://cdn.discordapp.com/emojis/${option.custom_emoji_data.id}.` +
				(option.custom_emoji_data.animated ? "gif" : "png");
			emoji_element = (
				<div>
					<img
						key={index}
						style={{ maxWidth: "1rem", maxHeight: "1rem" }}
						src={emoji_url}
					></img>
				</div>
			);
		} else {
			emoji_element = <p key={index}>{option.emoji}</p>;
		}

		rows.push(
			<tr key={index}>
				<td>{emoji_element}</td>
				<td>{option.name}</td>
				<td>{option.limit ? option.limit : "∞"}</td>
				<td>{option.has_reminders ? "Enabled" : "Disabled"}</td>
			</tr>
		);

		index++;
	}

	return (
		<table className="sesh-table mobilized-table">
			<thead>
				<tr>
					<th>Emoji</th>
					<th>Name</th>
					<th>Limit</th>
					<th>Reminders</th>
				</tr>
			</thead>
			<tbody>{rows}</tbody>
		</table>
	);
}
